var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.data),function(entry,index){return [_c('p',{key:index},[_c('strong',{style:({ color: entry.color })},[_vm._v(_vm._s(entry.label))])]),_c('dl',[_vm._l((entry.items),function(item,index){return [_c('dt',[_c('strong',[_vm._v(_vm._s(item.code))])]),_c('dd',[_vm._v(_vm._s(item.labels[_vm.locale]))])]})],2),_c('p')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }